export default __webpack_public_path__ + "static/media/short.7ac88bfe.png";